import { currentUtcMillis, getDateInCustomTimezone, getFullDateInCustomTimezone, getTimeInCustomTimezone } from 'utils/dateManagement';

export const getDeliveryTimeText = ({ order, timezone, isPrepare }) => {
  // Old records wont have prepare date
  if (!order.prepare_date) {
    // eslint-disable-next-line no-param-reassign
    isPrepare = false;
  }

  const deliveryOrder = order.deliveryOrder || order.delivery_order;

  // Has delivery + is prepare
  if (deliveryOrder && deliveryOrder.inform_type === 'Wolt' && isPrepare && deliveryOrder.pickup_date) {
    const currentDate = getDateInCustomTimezone(currentUtcMillis(), timezone);
    let formattedDateTime = getFullDateInCustomTimezone(deliveryOrder.pickup_date, timezone);

    if (formattedDateTime.includes(currentDate)) {
      formattedDateTime = formattedDateTime.replace(currentDate, 'Today');
    }

    return formattedDateTime;
  }

  // Has delivery + Not prepare
  if (deliveryOrder && deliveryOrder.inform_type === 'Wolt' && !isPrepare && deliveryOrder.delivery_date) {
    const currentDate = getDateInCustomTimezone(currentUtcMillis(), timezone);
    let formattedDateTime = getFullDateInCustomTimezone(deliveryOrder.delivery_date, timezone);

    if (formattedDateTime.includes(currentDate)) {
      formattedDateTime = formattedDateTime.replace(currentDate, 'Today');
    }

    return formattedDateTime;
  }

  // Delivery date should always exist, in case it doesnt, add 30 min to order date
  // eslint-disable-next-line no-nested-ternary
  const deliveryDate = isPrepare
    ? order.prepare_date ? order.prepare_date : order.date_utc + 30 * 60000
    : order.delivery_date ? order.delivery_date : order.date_utc + 30 * 60000;

  let earlyDeliveryDate;
  let lateDeliveryDate;

  const deltaTime = isPrepare ? order.prepare_date_delta : order.delivery_date_delta;

  if (deltaTime > 0) {
    earlyDeliveryDate = deliveryDate;
    lateDeliveryDate = deliveryDate + deltaTime * 60000;
  } else if (deltaTime < 0) {
    earlyDeliveryDate = deliveryDate - Math.abs(deltaTime) * 60000;
    lateDeliveryDate = deliveryDate;
  } else {
    earlyDeliveryDate = deliveryDate;
    lateDeliveryDate = deliveryDate;
  }

  const currentDate = getDateInCustomTimezone(currentUtcMillis(), timezone);
  let formattedDateTime = getFullDateInCustomTimezone(earlyDeliveryDate, timezone);

  if (lateDeliveryDate && earlyDeliveryDate !== lateDeliveryDate) {
    const formattedLateTime = getTimeInCustomTimezone(lateDeliveryDate, timezone);

    formattedDateTime = `${formattedDateTime} - ${formattedLateTime}`;
  }

  if (formattedDateTime.includes(currentDate)) {
    formattedDateTime = formattedDateTime.replace(currentDate, 'Today');
  }

  return formattedDateTime;
};
